import { Injectable, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as AuthActions from './auth.actions';
import * as AuthSelectors from './auth.selectors';
import {AuthenticationActions, UserActions, UserPermissionActions} from "./auth.actions";
import {User} from "@auth/lib/auth-http.interface";

@Injectable({ providedIn: 'root' })
export class AuthFacade {
  private readonly store = inject(Store);

  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.pipe(select(AuthSelectors.selectAuthLoaded));
  error$ = this.store.pipe(select(AuthSelectors.selectError));
  permissions$ = this.store.pipe(select(AuthSelectors.getUserPermissions));
  user$ = this.store.pipe(select(AuthSelectors.getUser));
  role$ = this.store.pipe(select(AuthSelectors.getRole));

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  init() {
    this.store.dispatch(AuthActions.initAuth());
  }

  signIn(identity: string, password: string) {
    this.store.dispatch(AuthenticationActions.signIn({ identity, password }));
  }

  oauthSignIn() {
    this.store.dispatch(AuthenticationActions.oAuthSignIn());
  }

  signOut() {
    this.store.dispatch(AuthenticationActions.signOut());
  }

  getPermissions(roleId: number) {
    this.store.dispatch(UserPermissionActions.getPermissions(roleId));
  }

  getUser() {
    this.store.dispatch(UserActions.getUser());
  }

  updateUser(user: Partial<User>) {
    this.store.dispatch(UserActions.updateUser({ user }));
  }

  changePassword({ currentPassword, password, passwordConfirmation } : { currentPassword: string, password: string, passwordConfirmation: string }) {
    this.store.dispatch(UserActions.changePassword({ currentPassword, password, passwordConfirmation }));
  }
}
